import $ from 'jquery';

// Add/remove header-expand class when main navigation collapses are toggled
$(function() {
  $('.main-navigation-collapse').on('show.bs.collapse shown.bs.collapse', function() {
    $('.header').addClass('header-expand');
  });
  $('.main-navigation-collapse').on('hidden.bs.collapse', function() {
    $('.header').removeClass('header-expand');
  });

  $('[data-toggle=\'tooltip\']').tooltip({
    placement: 'bottom',
    boundary: 'window',
    container: 'body'
  });

  //collapse the main navigation when it's open and a click occurs outside
  $('body').on('click', function(evt) {
    if ($('.header').hasClass('header-expand') && $(evt.target).parents('#header').length == 0) {
      $('.main-navigation-collapse').collapse('hide');
    }
  })
})